import { __, ns__, s__ } from '@design-system/i18n';
import { numberWithCurrency } from '@hivebrite/utils';
import { isLimitedRecurringItem } from './recurringItem';
import { CURRENCY_DISPLAY, periodicityTranslations } from '../constants';
export const generateRecurringLimitedPaymentText = (items, locale) => {
    var _a, _b;
    if (items.length === 0) {
        return '';
    }
    const recurringItemsForDescription = items.filter(isLimitedRecurringItem);
    if (recurringItemsForDescription.length === 0) {
        return '';
    }
    const groupedRecurringItems = {};
    for (const { currency: { code: currencyCode }, original_total: originalTotal, periodicity, quantity, recurring_count: recurringCount, } of recurringItemsForDescription) {
        const key = `${periodicity}-${recurringCount}`;
        if (!groupedRecurringItems[key]) {
            groupedRecurringItems[key] = {
                periodicity,
                recurringCount,
                perPaymentTotal: 0,
                currencyCode,
            };
        }
        const group = groupedRecurringItems[key];
        group.perPaymentTotal += (originalTotal || 0) * (quantity || 1);
    }
    const recurringPaymentDescriptions = Object.values(groupedRecurringItems).map((group) => {
        const { currencyCode, perPaymentTotal, periodicity, recurringCount } = group;
        if (!currencyCode) {
            throw new Error('Missing currency code for recurring payment');
        }
        const formattedPerPayment = numberWithCurrency({
            currency: { code: currencyCode },
            options: {
                currencyDisplay: CURRENCY_DISPLAY,
                locale,
            },
            value: perPaymentTotal,
        });
        const futureInstallments = recurringCount - 1;
        if (futureInstallments > 0) {
            return ns__('OrderSummary|%{paymentAmount} every %{period} for %{count} installment', 'OrderSummary|%{paymentAmount} every %{period} for %{count} installments', futureInstallments).i__({
                paymentAmount: formattedPerPayment,
                period: periodicityTranslations[periodicity],
                count: String(futureInstallments),
            });
        }
        return formattedPerPayment;
    });
    let grandTotal = 0;
    for (const item of items) {
        if (item.recurring && item.recurring_count) {
            const recurringTotal = (item.original_total || 0) *
                (item.quantity || 1) *
                item.recurring_count;
            grandTotal += recurringTotal;
        }
    }
    for (const item of items) {
        if (!item.recurring && item.original_total) {
            grandTotal += (item.original_total || 0) * (item.quantity || 1);
        }
    }
    const currency = (_b = (_a = items.find((item) => { var _a; return (_a = item.currency) === null || _a === void 0 ? void 0 : _a.code; })) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.code;
    if (!currency) {
        throw new Error('Missing currency code for total amount');
    }
    const formattedGrandTotal = numberWithCurrency({
        currency: { code: currency },
        options: {
            currencyDisplay: CURRENCY_DISPLAY,
            locale,
        },
        value: grandTotal,
    });
    const paymentText = s__('OrderSummary|Then %{recurringPaymentsString} for a total of %{totalAmount}.').i__({
        recurringPaymentsString: recurringPaymentDescriptions.join(`, ${__('and')} `),
        totalAmount: formattedGrandTotal,
    });
    return paymentText;
};
//# sourceMappingURL=generateRecurringLimitedPaymentText.js.map